/**
 * Hand a fetched file to the device's own viewer or downloads (Kelvo step 3c).
 *
 * The Worker already sends every original as an attachment; this is the other
 * half, for a file that had to be fetched with a signed-in request rather than
 * followed as a link. An object URL, a click on a download anchor, and the URL
 * revoked afterwards — generously, because a phone may take a moment to hand the
 * file to its viewer, and revoking early turns a download into an empty file.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
